<div class="collapsable-container">
  <div class="collapsable-container-header" (click)="toggleCollapse()">
      <span class="btn-collapse" (click)="toggleCollapse()"
      >
        <span class="fa fa-fw fa-angle-double-down"></span>
      </span>
      <div class="heading">{{ 'SISTRADNIHMESTA.RADNOMESTOIBROJIZVRSILACA.TITLE' | translate }}</div>
  </div>
  <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
      <app-sist-radnih-mesta-stavka-update #baseUpdate></app-sist-radnih-mesta-stavka-update>
      <div class="row">
          <div class="col-md-12">
              <div class="btn-group float-right">
                  <button type="button" class="btn btn-outline-primary" (click)="Save()" [disabled]="saveDisabled"><span class="fa fa-fa fa-save"></span></button>
                  <button type="button" class="btn btn-outline-primary" (click)="Reset()"><span translate="FW.ACTION.CANCEL"></span></button>
              </div>
          </div>
      </div>
  </div>
</div>